<template>
  <div>
    <div class="d-flex mb-3 align-items-baseline border-bottom">
      <h3 class="h5 fw-700 mb-0">
        <span
          class="border-bottom border-primary border-width-2 pb-3 d-inline-block"
          >{{ title }}</span
        >
      </h3>
      <router-link
        v-if="buttonName"
        :to="buttonHref || 'javascript:void(0)'"
        class="ml-auto mr-0 btn btn-primary btn-sm shadow-md"
        >{{ buttonName }}
      </router-link>
    </div>
    <div class="row gutters-5">
      <div v-for="item in list" :key="item.id" class="col-sm-6">
        <router-link
          :to="item.to"
          class="bg-white border d-block text-reset rounded p-2 hov-shadow-md mb-2"
        >
          <div class="row align-items-center no-gutters">
            <div class="col-3 text-center">
              <img
                :src="getFileViewUrl(item.pic)"
                alt
                class="img-fluid img h-60px ls-is-cached lazyloaded"
              />
            </div>
            <div class="col-7">
              <div class="text-truncat-2 pl-3 fs-14 fw-600 text-left">
                {{ $t(item.name) }}
              </div>
            </div>
            <div class="col-2 text-center">
              <i class="la la-angle-right text-primary"></i>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    buttonName: String,
    buttonHref: String,
    list: Array
  }
};
</script>
